import type { Router } from 'app/app-state';
import { setCurrentProject } from 'app/project/actions';
import cloneDeep from 'lodash/cloneDeep';
import { type ActionType, createAction, createReducer } from 'typesafe-actions';
import type { API_PANEL_ID } from './constants.js';

export const NAME = 'workbench';

export type WorkbenchSlice = {
  [NAME]: WorkbenchState;
};

export type WorkbenchState = {
  lastScratchSave: number;
  setupApiIndexingOpen: boolean;
  expandPanelRequest?: string;
};

export const initialState: WorkbenchState = {
  lastScratchSave: 0,
  setupApiIndexingOpen: false
};

export type ApiIndexStartPayload = {
  shapeName: string;
};

export type ApiIndexEndPayload = {
  serviceId?: string;
  shapeName: string;
  duration: number;
  successful: number;
  failed: number;
  deleted: number;
  deleteFailed: number;
  errors: string[];
};

export type ApiIndexErrorPayload = {
  shapeName: string;
  message: string;
};

export type RouterLocationChangedPayload = Router;

export const setLastScratchSave = createAction(`${NAME}/SET_LAST_SCRATCH_SAVE`)<number>();
export const apiIndexStart = createAction('collab/API_INDEX_START')<ApiIndexStartPayload>();
export const apiIndexEnd = createAction('collab/API_INDEX_END')<ApiIndexEndPayload>();
export const apiIndexError = createAction('collab/API_INDEX_ERROR')<ApiIndexErrorPayload>();
export const routerLocationChanged = createAction('ROUTER_LOCATION_CHANGED')<RouterLocationChangedPayload>();
export const expandPanel = createAction('EXPAND_PANEL')<API_PANEL_ID | undefined>();

type WorkbenchAction =
  | ActionType<typeof setCurrentProject>
  | ActionType<typeof setLastScratchSave>
  | ActionType<typeof expandPanel>;

export const reducer = createReducer<WorkbenchState, WorkbenchAction>(initialState)
  .handleAction(setCurrentProject, () => cloneDeep(initialState))
  .handleAction(setLastScratchSave, (state, { payload }) => ({
    ...state,
    lastScratchSave: payload
  }))
  .handleAction(expandPanel, (state, { payload }) => ({
    ...state,
    expandPanelRequest: payload
  }));
